export class FeatureFlag {
  readonly key: string;
  readonly enabled: boolean;
  readonly variant: string | undefined;

  constructor(key: string, enabled: boolean, variant?: string) {
    this.key = key;
    this.enabled = enabled;
    this.variant = variant;
  }
}
